import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import colors from "../../../../../resources/colors";
import si from "../../../../../Pages/SignUp/Steps/InvitationEmail/style.scss";
import s from "./style.scss";
import smimg from "../../../../../../src/resources/images/alarm.png";
import { Grid, Link } from "@material-ui/core";
import { useInput } from "../../../../../hooks";
import { Button as CustomButton, InputText, } from "../../../../../components/Shared/Controls";
import { getPatientAddressesAsyncAction } from "../../../../../store";
import { connect } from "react-redux";
import { putPatientPharmacyAsyncAction, getPharmaciesAsyncAction, getPatientPharmacyAsyncAction, postPharmacyInfoAsyncAction } from "../../../../../store/pharmacy/Sagas";
import LoadingPopUp from "../../../../../components/Shared/LoadingPopUp";
import MapContainerMultiple from "../../../../../components/MapContainerMultiple";
import Typography from "../../../../../components/Shared/Typography";
import { resetPostPharmacyInfoAction, resetPutPharmacyInfoAction } from "../../../../../store/pharmacy";
import { useNavigate } from "react-router";
import GooglePlacesAutocomplete, { geocodeByAddress, getLatLng } from "react-google-places-autocomplete";
const AddPharmacyPharmacy = ({ patientId, address, setStep, nextStep, previousStep, getPharmaciesAction, getOnlyPharmacyData, requestGetPharmacyStatus, postPharmacyInfo, requestGetOnlyPharmacyStatus, requestPharmacyPostDataStatus, resetPostPharmacyAction, isNewSignUp, getPharmacyData, getPatientPharmacyAction, PutPharmacyAsyncAction, resetPutPharmacyAction, requestPutPharmacyStatus, isDashboard, getPatientAddresses }) => {
    const { t } = useTranslation();
    const [isLoaded, setIsLoaded] = useState(false);
    const [currentTab, setCurrentTab] = useState({
        key: "searchByYourAddress",
    });
    const [currentLocation, setCurrentLocation] = useState(null);
    const navigate = useNavigate();
    const [haveChanges, setHaveChanges] = useState(false);
    const [clinicName, setClinicName, errorClinicName, setErrorClinicName] = useInput();
    const [clinicAddress, setClinicAddress, errorClinicAddress, setErrorClinicAddress] = useInput();
    const [addressLocation, setAddressLocation] = useState();
    const [skipStep, setSkipStep] = useState();
    const [selectedData, setSelectedData] = useState(null);
    const [tmpLocationArray, setTemLocationArray] = useState([]);
    const [youAreSureModal, setYouAreSureModal] = useState({ show: false });
    const clickOnTab = (key) => {
        !haveChanges
            ? setCurrentTab({ key })
            : setYouAreSureModal({ show: true, key: key });
    };
    const tabs = [
        {
            key: "searchByYourAddress",
            title: t("searchByYourAddress"),
        },
        {
            key: "searchByName",
            title: t("searchByName"),
        },
    ];
    useEffect(() => {
        if (currentTab.key == "searchByName") {
            setClinicAddress("");
            setAddressLocation(null);
        }
        if (currentTab.key == "searchByYourAddress") {
            setClinicName("");
        }
        setSelectedData(null);
    }, [currentTab]);
    const storeStepsToCompleteData = localStorage.getItem('storeStepsToCompleteData');
    useEffect(() => {
        const stepsToCompleteData = JSON.parse(storeStepsToCompleteData);
        if (stepsToCompleteData.length > 0) {
            const DataSkipStep = stepsToCompleteData;
            for (let data of DataSkipStep) {
                if (data?.step == "Pharmacy" && data?.mandatory == true) {
                    setSkipStep(true);
                }
                else {
                    setSkipStep(false);
                }
            }
        }
    }, [storeStepsToCompleteData]);
    const Submit = () => {
        if (getPharmacyData?.length > 0) {
            const data = {
                id: getPharmacyData?.[0]?.patientBrandPharmacyId,
                name: selectedData.name,
                address: selectedData.address,
                city: selectedData.city,
                country: selectedData.country,
                province: selectedData.province,
                phone: selectedData.phone,
                longitude: selectedData.longitude,
                latitude: selectedData.latitude,
                brandIdentifier: selectedData.brandIdentifier,
                note: selectedData.note
            };
            PutPharmacyAsyncAction(data);
        }
        else {
            const data = {
                name: selectedData.name,
                address: selectedData.address,
                city: selectedData.city,
                country: selectedData.country,
                province: selectedData.province,
                phone: selectedData.phone,
                longitude: selectedData.longitude,
                latitude: selectedData.latitude,
                brandIdentifier: selectedData.brandIdentifier,
                note: selectedData.note
            };
            postPharmacyInfo(data);
        }
    };
    const handleAddPharmacy = () => {
        if (isNewSignUp) {
            setStep({ step: "PharmacyManual", mandatory: false });
        }
        if (isDashboard) {
            navigate('/pharmacy/add-pharmacy/add-my-own-pharmacy');
        }
    };
    const setSelectedDataFun = (data) => {
        setSelectedData(data);
    };
    const handlePinSelected = (location) => {
        let lat = location.latLng?.lat();
        let long = location.latLng?.lng();
        let clinic = getOnlyPharmacyData?.find(c => c.latitude == lat && c.longitude == long);
        setSelectedData(clinic);
    };
    useEffect(() => {
        if (getOnlyPharmacyData) {
            const tmpLocation = [];
            for (let i = 0; i < getOnlyPharmacyData?.length; i++) {
                tmpLocation.push({
                    id: getOnlyPharmacyData[i].PharmacyId,
                    lat: getOnlyPharmacyData[i].latitude,
                    lng: getOnlyPharmacyData[i].longitude,
                });
            }
            if (getPharmacyData?.length > 0 && !getOnlyPharmacyData?.some(p => p.brandIdentifier == getPharmacyData?.[0]?.brandIdentifier)
                && !!getPharmacyData[0].latitude && !!getPharmacyData[0].longitude) {
                tmpLocation.push({
                    id: getPharmacyData[0].id,
                    lat: getPharmacyData[0].latitude,
                    lng: getPharmacyData[0].longitude,
                });
            }
            setTemLocationArray(tmpLocation);
        }
    }, [getOnlyPharmacyData]);
    useEffect(() => {
        // getPharmaciesAction({});
        getPatientAddresses();
        getPatientPharmacyAction({ patientId });
    }, []);
    // useEffect(() => {
    //     if (clinicAddress == null && clinicName == "") {
    //         // getPharmaciesAction({});
    //         setSelectedData(null);
    //     }
    // }, [clinicName, clinicAddress])
    const searchFunction = () => {
        if (clinicName != '') {
            setSelectedData(null);
            getPharmaciesAction({ name: clinicName, address: '', rowsPerPage: 50 });
        }
        if (addressLocation != null) {
            setSelectedData(null);
            getPharmaciesAction({ name: '', address: '', latitude: addressLocation.lat, longitude: addressLocation.lng, rowsPerPage: 50 });
        }
    };
    useEffect(() => {
        if (requestPharmacyPostDataStatus === "success" && isNewSignUp) {
            resetPostPharmacyAction();
            nextStep(true);
        }
        if (requestPharmacyPostDataStatus === "success" && isDashboard) {
            resetPostPharmacyAction();
            navigate('/pharmacy');
        }
    }, [requestPharmacyPostDataStatus]);
    useEffect(() => {
        if (requestPutPharmacyStatus == "success" && isNewSignUp) {
            resetPutPharmacyAction();
            nextStep(true);
        }
        if (requestPutPharmacyStatus == "success" && isDashboard) {
            resetPutPharmacyAction();
            navigate("/pharmacy");
        }
    }, [requestPutPharmacyStatus]);
    const NavigateFunction = () => {
        if (isDashboard) {
            navigate('/pharmacy/select-pharmacy');
        }
    };
    useEffect(() => {
        if (getPharmacyData?.length > 0) {
            setSelectedData(getPharmacyData?.[0]);
        }
    }, [getPharmacyData]);
    const getPharmaciesByGeocode = () => {
        const geocoder = new google.maps.Geocoder();
        console.log("Geocoding: " + address?.postalCode);
        geocoder.geocode({ address: address?.postalCode }, function (results, status) {
            console.log(status, results);
            if (status === "OK" && results != null) {
                getPharmaciesAction({ name: '', address: '', rowsPerPage: 50,
                    longitude: results[0].geometry.location.lng(),
                    latitude: results[0].geometry.location.lat()
                });
            }
            else {
                getPharmaciesAction({ name: '', address: address?.street, rowsPerPage: 50 });
                console.log("Geocoding was not successful for the following reason: " + status);
            }
        });
    };
    const getPharmaciesBasedOnUserLocation = () => {
        // if (currentLocation) {
        //     getPharmaciesAction({ name: '', address: '',
        //         longitude: currentLocation.lng,
        //         latitude: currentLocation.lat
        //     });
        // } else 
        if (address) {
            if (address.postalCode) {
                setClinicAddress('');
                getPharmaciesByGeocode();
            }
            else if (address.street) {
                setClinicAddress(address?.street);
                getPharmaciesAction({ name: '', address: address?.street, rowsPerPage: 50 });
            }
            else {
                setClinicAddress('');
                getPharmaciesAction({ name: '', address: '', rowsPerPage: 50,
                    longitude: -79.3831843,
                    latitude: 43.653226
                });
            }
        }
        else {
            setClinicAddress('');
            getPharmaciesAction({ name: '', address: '', rowsPerPage: 50,
                longitude: -79.3831843,
                latitude: 43.653226
            });
        }
    };
    useEffect(() => {
        if (!isLoaded || requestGetPharmacyStatus !== "success")
            return;
        if (getPharmacyData?.length > 0 && getPharmacyData?.[0]?.name && currentTab.key == "searchByName") {
            setClinicName(getPharmacyData?.[0]?.name);
            getPharmaciesAction({ name: getPharmacyData?.[0]?.name, address: '', rowsPerPage: 50 });
        }
        else {
            getPharmaciesBasedOnUserLocation();
        }
    }, [getPharmacyData, currentTab.key, isLoaded, address]);
    const getGoogleMapsLink = (item) => {
        if (item?.latitude && item?.longitude) {
            let link = `https://www.google.com/maps/search/${item?.latitude}, ${item?.longitude}/@${item?.latitude},${item?.longitude},10z`;
            return link;
        }
        let link = `https://www.google.com/maps/search/${item?.address}`;
        if (!!item?.city) {
            link += ` ${item?.city}`;
        }
        if (!!item?.country) {
            link += ` ${item?.country}`;
        }
        if (!!item?.postal) {
            link += ` ${item?.postal}`;
        }
        return link;
    };
    const renderTab = () => {
        switch (currentTab.key) {
            case "searchByYourAddress":
                return React.createElement(React.Fragment, null,
                    React.createElement("div", { className: classNames(si.contentInput) },
                        React.createElement("div", { className: classNames(si.formGroup) },
                            React.createElement("label", null, t("enterPharmacyAddress")),
                            React.createElement("div", { className: classNames(s.formGroupsearch) },
                                React.createElement(GooglePlacesAutocomplete, { apiKey: "AIzaSyC10P0ckGNI2GUddp7kNz03ZqFE67ODacs", selectProps: {
                                        value: clinicAddress,
                                        isClearable: true,
                                        controlShouldRenderValue: true,
                                        onChange: (place) => {
                                            setClinicAddress(place);
                                            if (!!place) {
                                                geocodeByAddress(place.label)
                                                    .then((res) => getLatLng(res[0]))
                                                    .then((location) => {
                                                    console.log('Successfully got latitude and longitude', location);
                                                    setAddressLocation(location);
                                                });
                                            }
                                            else {
                                                getPharmaciesBasedOnUserLocation();
                                            }
                                        },
                                        styles: {
                                            control: (props) => ({
                                                ...props,
                                                backgroundColor: colors.primaryshades3,
                                                height: 56,
                                                border: "1px solid #e0e1e2",
                                                marginTop: 8
                                            })
                                        }
                                    } }),
                                React.createElement(CustomButton, { onClick: () => { searchFunction(); }, primary: true, text: t("search") })))));
            case "searchByName":
                return React.createElement(React.Fragment, null,
                    React.createElement("div", { className: classNames(si.contentInput) },
                        React.createElement("div", { className: classNames(si.formGroup) },
                            React.createElement("label", null, t("enterPharmacyName")),
                            React.createElement("div", { className: classNames(s.formGroupsearch) },
                                React.createElement(InputText, { name: "clinicName", pattern: '^.{0,35}$', value: clinicName, setValue: setClinicName, error: clinicName && errorClinicName, setError: setErrorClinicName, tabIndex: 1, onCancel: getPharmaciesBasedOnUserLocation }),
                                React.createElement(CustomButton, { style: s.mt0_button, onClick: () => { searchFunction(); }, primary: true, text: t("search") })))));
            default:
                return React.createElement("div", null);
        }
    };
    return (React.createElement("div", { className: classNames(si.contentWrapper) },
        React.createElement("div", { className: classNames(si.scrollWrapperfrom) },
            React.createElement("div", { className: classNames(si.formWrapper, s.hiddenscroll, s.pb20) },
                React.createElement("div", { className: classNames(si.formstepbar) },
                    React.createElement("div", { className: s.header },
                        React.createElement("div", { className: s.pages }, isNewSignUp ?
                            React.createElement(React.Fragment, null,
                                React.createElement(Typography, { type: 'subtitle_2', color: 'neutralGray' }, `13/15`)) : null)),
                    React.createElement(Grid, { container: true, spacing: 2 },
                        React.createElement(Grid, { item: true, xs: 12, md: 6 },
                            React.createElement("div", { className: (si.stepToptext) },
                                getPharmacyData?.length > 0 ? React.createElement(React.Fragment, null,
                                    React.createElement("h4", null, t("updatePharmacy"))) : React.createElement(React.Fragment, null,
                                    React.createElement("h4", null, t("addPharmacy"))),
                                React.createElement("div", { className: s.text },
                                    React.createElement("p", null, t("choosePharmacy"))))),
                        React.createElement(Grid, { item: true, xs: 12, md: 6, className: (si.addPharmacyBtn) },
                            React.createElement(CustomButton, { primary: true, text: t("addMyOwnPharmacy"), onClick: () => { handleAddPharmacy(); } }))),
                    React.createElement("div", { className: s.navBar }, tabs.map((tab) => (React.createElement("div", { key: tab.key, className: classNames({ [s.active]: tab.key === currentTab.key }), style: {
                            borderColor: colors.tabBorderColor
                        }, title: tab.title, onClick: () => clickOnTab(tab.key) }, tab.title)))),
                    React.createElement("div", null,
                        React.createElement(Grid, { container: true, spacing: 2 },
                            React.createElement(Grid, { item: true, xs: 12, md: 6 },
                                React.createElement(React.Fragment, null,
                                    React.createElement("div", { className: classNames(s.mt15) },
                                        React.createElement("div", null, renderTab()),
                                        !!address && React.createElement("div", null,
                                            t("searchingOn"),
                                            ": ",
                                            !!clinicAddress ? clinicAddress.label : !!clinicName ? clinicName : address.postalCode ?? address.street),
                                        React.createElement("div", { className: classNames(s.ClinicList, s.ClinicListPharmacy) },
                                            getPharmacyData?.length > 0 && !getOnlyPharmacyData?.some(p => p.brandIdentifier == getPharmacyData?.[0]?.brandIdentifier) &&
                                                React.createElement("ul", null,
                                                    React.createElement("li", { key: "solo", onClick: () => setSelectedDataFun(getPharmacyData[0]), className: selectedData == getPharmacyData[0] ? s.addressActive : null },
                                                        React.createElement("h3", null, t("current")),
                                                        React.createElement("h3", null,
                                                            t("name"),
                                                            ": ",
                                                            getPharmacyData[0]?.name),
                                                        React.createElement("p", { className: si.m0 },
                                                            " ",
                                                            t("address"),
                                                            ": ",
                                                            getPharmacyData[0]?.address,
                                                            " ",
                                                            getPharmacyData[0]?.city,
                                                            !!getPharmacyData[0]?.province && ", " + getPharmacyData[0]?.province,
                                                            !!getPharmacyData[0]?.postal && ", " + getPharmacyData[0]?.postal),
                                                        React.createElement("p", { className: si.m0 },
                                                            " ",
                                                            t("phone"),
                                                            ": ",
                                                            getPharmacyData[0]?.phone,
                                                            " "),
                                                        React.createElement("div", { className: classNames(s.GetDirectionsbox) },
                                                            React.createElement("div", { className: classNames(s.GetDirectionsboxtext) },
                                                                React.createElement(Link, { href: getGoogleMapsLink(getPharmacyData[0]), target: "_blank", className: si.GetDirectionsboxlink },
                                                                    " ",
                                                                    t("getdirections"),
                                                                    " ")),
                                                            React.createElement("div", { className: classNames(s.GetDirectionsboxImg) },
                                                                React.createElement("img", { src: smimg, className: "img-fluid" }))))),
                                            getOnlyPharmacyData && getOnlyPharmacyData.length > 0 ? React.createElement(React.Fragment, null,
                                                React.createElement("ul", null, getOnlyPharmacyData?.map((item, index) => (React.createElement("li", { key: index, onClick: () => setSelectedDataFun(item), className: selectedData?.name === item?.name ? s.addressActive : null },
                                                    React.createElement("h3", null,
                                                        t("name"),
                                                        ": ",
                                                        item?.name),
                                                    React.createElement("p", { className: si.m0 },
                                                        " ",
                                                        t("address"),
                                                        ": ",
                                                        item?.address,
                                                        " ",
                                                        item?.city,
                                                        !!item?.province && ", " + item?.province,
                                                        !!item?.postal && ", " + item?.postal),
                                                    React.createElement("p", { className: si.m0 },
                                                        " ",
                                                        t("phone"),
                                                        ": ",
                                                        item?.phone,
                                                        " "),
                                                    React.createElement("div", { className: classNames(s.GetDirectionsbox) },
                                                        React.createElement("div", { className: classNames(s.GetDirectionsboxtext) },
                                                            React.createElement(Link, { href: getGoogleMapsLink(item), target: "_blank", className: si.GetDirectionsboxlink },
                                                                " ",
                                                                t("getdirections"),
                                                                " ")),
                                                        React.createElement("div", { className: classNames(s.GetDirectionsboxImg) },
                                                            React.createElement("img", { src: smimg, className: "img-fluid" }))))))))
                                                : React.createElement("h3", null, "No records found"))))),
                            React.createElement(Grid, { item: true, xs: 12, md: 6 },
                                React.createElement("div", { className: s.mapWrapper },
                                    React.createElement(MapContainerMultiple, { locations: tmpLocationArray, address: address?.postalCode, setIsLoaded: setIsLoaded, handlePinSelected: handlePinSelected, selectedLocation: !!selectedData && !!selectedData.latitude ? {
                                            lat: selectedData.latitude,
                                            lng: selectedData.longitude
                                        } : null, setCurrentLocation: setCurrentLocation })))),
                        React.createElement("div", { className: si.buttonTwopage },
                            React.createElement(CustomButton, { text: t("back"), onClick: isNewSignUp ? previousStep : NavigateFunction }),
                            React.createElement(CustomButton, { style: s.mb0_button, primary: true, disabled: selectedData == null || selectedData?.brandIdentifier == getPharmacyData?.[0]?.brandIdentifier, text: t("SaveProceed"), onClick: Submit })))))),
        requestGetPharmacyStatus === "pending" ? React.createElement(LoadingPopUp, { isOpen: true }) : null,
        requestGetOnlyPharmacyStatus === "pending" ? React.createElement(LoadingPopUp, { isOpen: true }) : null,
        requestPharmacyPostDataStatus === "pending" ? React.createElement(LoadingPopUp, { isOpen: true }) : null,
        requestPutPharmacyStatus === "pending" ? React.createElement(LoadingPopUp, { isOpen: true }) : null));
};
const mapStateToProps = (state) => {
    return {
        patientId: state.account.user.patientId ?? "",
        address: state.patientAddress.setAddressData,
        getOnlyPharmacyData: state.pharmacy.getOnlyPharmacyData,
        requestGetPharmacyStatus: state.pharmacy.requestGetPharmacyStatus,
        requestGetOnlyPharmacyStatus: state.pharmacy.requestGetOnlyPharmacyStatus,
        requestPharmacyPostDataStatus: state.pharmacy.requestPharmacyPostDataStatus,
        getPharmacyData: state.pharmacy.getPharmacyData,
        requestPutPharmacyStatus: state.pharmacy.requestPutPharmacyStatus
    };
};
function mapDispatchToProps(dispatch) {
    return {
        getPharmaciesAction: (data) => dispatch(getPharmaciesAsyncAction(data)),
        getPatientAddresses: () => dispatch(getPatientAddressesAsyncAction()),
        postPharmacyInfo: (data) => dispatch(postPharmacyInfoAsyncAction(data)),
        resetPostPharmacyAction: () => dispatch(resetPostPharmacyInfoAction()),
        getPatientPharmacyAction: (data) => dispatch(getPatientPharmacyAsyncAction(data)),
        getPatientAddressesAction: () => dispatch(getPatientAddressesAsyncAction()),
        PutPharmacyAsyncAction: (data) => dispatch(putPatientPharmacyAsyncAction(data)),
        resetPutPharmacyAction: () => dispatch(resetPutPharmacyInfoAction())
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(AddPharmacyPharmacy);
